import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu, X, Shield } from "lucide-react";

export function ResponsiveShell({ title, subtitle, widthClass = "w-64", children, content }) {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-slate-50">
      <header className="lg:hidden sticky top-0 z-30 bg-navy-900 text-white px-4 py-3 flex items-center justify-between no-print" data-testid="mobile-topbar">
        <div className="flex items-center gap-2.5 min-w-0">
          <div className="w-8 h-8 rounded-sm bg-brass-500 flex items-center justify-center flex-shrink-0">
            <Shield className="w-4 h-4 text-navy-900" />
          </div>
          <div className="min-w-0">
            <div className="font-heading font-bold text-[11px] uppercase tracking-widest truncate">{title}</div>
            <div className="text-[9px] text-brass-400 uppercase tracking-wider">{subtitle}</div>
          </div>
        </div>
        <button onClick={() => setOpen(true)} data-testid="mobile-menu-btn" aria-label="Buka menu" className="p-2 rounded-sm hover:bg-navy-800 transition-colors">
          <Menu className="w-5 h-5" />
        </button>
      </header>

      <div onClick={() => setOpen(false)} data-testid="mobile-menu-overlay"
        className={`lg:hidden fixed inset-0 z-40 bg-navy-900/60 backdrop-blur-sm transition-opacity no-print ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`} />

      <aside className={`${widthClass} bg-navy-900 text-white flex-shrink-0 flex flex-col no-print fixed lg:sticky top-0 left-0 z-50 h-screen lg:h-auto lg:min-h-screen max-w-[85vw] transition-transform duration-300 ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}>
        <button onClick={() => setOpen(false)} data-testid="mobile-menu-close" aria-label="Tutup menu" className="lg:hidden absolute top-4 right-3 p-1.5 rounded-sm text-white/70 hover:bg-navy-800">
          <X className="w-5 h-5" />
        </button>
        {children}
      </aside>

      <main className="flex-1 min-w-0 overflow-x-auto">{content}</main>
    </div>
  );
}
